
import { cn } from '@/lib/utils';
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon?: React.ReactNode;
  change?: string;
  positive?: boolean;
  className?: string;
}

export const StatsCard = ({ 
  title, 
  value, 
  icon, 
  change, 
  positive, 
  className 
}: StatsCardProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className={cn(
      "p-4 md:p-6 rounded-lg bg-card transition-all duration-300 hover:shadow-lg hover:shadow-primary/5",
      className
    )}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs md:text-sm font-medium text-muted-foreground">{title}</p>
          <h3 className={`${isMobile ? "text-lg" : "text-2xl"} font-bold mt-1`}>{value}</h3>
          {change && (
            <span className={cn(
              "text-xs font-medium mt-1 inline-block",
              positive ? "text-green-500" : "text-red-500"
            )}>
              {change}
            </span>
          )}
        </div>
        {icon && (
          <div className="bg-primary/10 p-1.5 md:p-2 rounded-md">
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};
